import selector from 'utils/selector'
import Pager from 'utils/pager'
import services from 'services'
import APIService from './APIService'
import {Message, Optional} from 'data/types'
import _ from 'lodash'
import {Subscription} from 'rxjs'
import {Published} from 'utils/published'
import {RealtimeEvent} from 'data/events'

export default class ChatService {
  private threadId: string

  private subscriptions: Subscription[] = []
  private pager = new Pager<Message>(50)

  public get messages(): Published<Message[]> {
    return this.pager.items
  }

  public dispose = () => {
    this.subscriptions.forEach((s) => s.unsubscribe())
  }

  public constructor(threadId: string) {
    this.threadId = threadId
    this.load().then(() => {
      this.connect()
    })
  }

  private connect = async () => {
    const rtSubscription = services
      .getRealtimeService()
      .observe<RealtimeEvent>(`events/${this.threadId}`)
      .skip(1)
      .filter((e) => e.event === 'new_message')
      .subscribe((updates) => {
        this.refreshMessages(updates.payload.lastUpdatedAt)
      })

    this.subscriptions.push(rtSubscription)
  }

  private refreshMessages = async (date: string) => {
    const collectionWrapper = _(this.messages.value)
    const response = await APIService.getMessages(this.threadId, {
      startScope: collectionWrapper.first()?.createdAt,
      endScope: date,
    })
    if (response.ok) {
      this.messages.publish(response.body)
    }
  }

  private load = async () => {
    this.messages.startLoading()
    const response = await APIService.getMessages(this.threadId, {endScope: _(this.messages.value).first()?.createdAt})
    if (response.ok) {
      this.messages.publish(response.body)
    }
    this.messages.endLoading()
  }

  public post = async (messageInput: Partial<Message>) => {
    const response = await APIService.postChatMessage(this.threadId, messageInput)
    if (response.ok) {
      this.messages.reduce((messages) => messages.concat(response.body))
    }
  }
}

type SelectorInput = {
  token: string
  threadId: string
}

const tokenSelector = (input: SelectorInput) => input.token
const threadIdSelector = (input: SelectorInput) => input.threadId

let currentChatService: Optional<ChatService> = null
export const chatServiceSelector = selector(tokenSelector, threadIdSelector, (token, threadId) => {
  currentChatService?.dispose()
  const cs = new ChatService(threadId)
  currentChatService = cs
  return cs
})
